import { useMemo } from "react";
import moment from "moment";
import { useQuery } from "@apollo/client";

import { getGroupCapacityAndAllocatedFte } from "src/queries/memberships.graphql";
import { getStartEndDate } from "./utils";

/* eslint-disable import/prefer-default-export */
export const useChartData = (supplyGroup) => {
  const groupId = supplyGroup?.id;

  const { apiStartDate, apiEndDate } = useMemo(() => {
    return getStartEndDate();
  }, []);

  const { data, loading, error } = useQuery(getGroupCapacityAndAllocatedFte, {
    variables: {
      input: {
        groupId,
        startDate: apiStartDate,
        endDate: apiEndDate,
      },
    },
    fetchPolicy: "cache-and-network",
    skip: !groupId,
  });

  if (!groupId) {
    return {
      chartData: [
        {
          date: moment(),
          capacityFte: 0,
          allocatedFte: 0,
        },
      ],
      loading: false,
    };
  }

  return {
    chartData: (data?.result.dateRangeList || []).slice(0, -1),
    loading,
    error,
  };
};
